import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import {InforistorantePage} from '../../pages/inforistorante/inforistorante';
import {CapconsegnaPage} from '../../pages/capconsegna/capconsegna';
import {OrarioPage} from '../../pages/orario/orario';

/**
 * Generated class for the ImpostazionePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-impostazione',
  templateUrl: 'impostazione.html',
})
export class ImpostazionePage {
  caps: string[];
  errorMessage: string;

  constructor(public navCtrl: NavController,
             public rest: RestApiProvider,
             

   ) {

 

  }
  
  openInforistorantePage() {

    this.navCtrl.push(InforistorantePage);

  }
  openCapconsegnaPage() {

    this.navCtrl.push(CapconsegnaPage);

  }
  openOrarioPage() {

    this.navCtrl.push(OrarioPage);

  }
}



// WEBPACK FOOTER //
// ./src/pages/impostazione/impostazione.ts